import React from 'react';
import { observer } from 'mobx-react-lite';
import { convertAmount, maskName, useTranslation } from '@pascal/pascal-core';

import { TranslationKeys } from '../../enums/translationKeys';
import { liveBetsDataStore } from '../../store/liveBetsDataStore';

const LiveBets = observer(() => {
  const { liveBets } = liveBetsDataStore;
  const t = useTranslation();

  return (
    <div className='winning-table-wrapper'>
      <input type='checkbox' id='winning-table-trigger' />
      <div className='winning-table'>
        <div className='winning-table-head'>
          <div className='winning-table-head-cell'>{t(TranslationKeys.User)}</div>
          <div className='winning-table-head-cell'>{t(TranslationKeys.Bet_1)}</div>
          <div className='winning-table-head-cell'>{t(TranslationKeys.Odd)}</div>
          <div className='winning-table-head-cell'>{t(TranslationKeys.Win)}</div>
        </div>
        <div className='winning-table-body-wrapper'>
          <div className='winning-table-body'>
            {liveBets.map(({ userId, amount, winAmount, odd, id, freeBetId }) => (
              <div className='winning-table-body-row' key={id}>
                <div className='winning-table-cell'>id: {maskName(userId)}</div>
                <div className='winning-table-cell'>
                  {freeBetId ? t(TranslationKeys.FreeBet) : convertAmount(amount)}
                </div>
                <div className='winning-table-cell'>x{convertAmount(odd)}</div>
                <div className='winning-table-cell'>{winAmount && convertAmount(winAmount)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <label
        htmlFor='winning-table-trigger'
        className='winning-table-toggle'
        data-more-label={t(TranslationKeys.ShowMore)}
        data-less-label={t(TranslationKeys.ShowLess)}
      >
        <span className='winning-table-toggle-arrow icon-chevron' />
      </label>
    </div>
  );
});

export default LiveBets;
